import { render, staticRenderFns } from "./OrdenCompraList.vue?vue&type=template&id=0f3fecf8&scoped=true&"
import script from "./OrdenCompraList.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraList.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraList.vue?vue&type=style&index=0&id=0f3fecf8&lang=scss&scoped=true&"
import style1 from "./OrdenCompraList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./OrdenCompraList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3fecf8",
  null
  
)

export default component.exports